import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import NettoyageHero from './components/NettoyageHero';
import NettoyageServices from './components/NettoyageServices';
import NettoyageProcess from './components/NettoyageProcess';
import NettoyageTarifs from './components/NettoyageTarifs';
import NettoyageCTA from './components/NettoyageCTA';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Nettoyage & Conciergerie Genève - HB SERVICES",
  "provider": {
    "@type": "LocalBusiness",
    "name": "HB SERVICES",
    "telephone": "+41797616282",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Meyrin",
      "addressRegion": "Genève",
      "addressCountry": "CH"
    }
  },
  "areaServed": ["Genève", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Nettoyage professionnel et conciergerie à Genève et en Suisse romande. Bureaux, appartements, immeubles, fin de chantier.",
  "serviceType": "Nettoyage et conciergerie",
  "url": `${import.meta.env.VITE_SITE_URL}/nettoyage-conciergerie`
};

export default function NettoyageConciergerie() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Nettoyage & Conciergerie Genève | Service Professionnel Suisse Romande - HB SERVICES"
        description="HB SERVICES : nettoyage professionnel et conciergerie à Genève et en Suisse romande. Bureaux, appartements, immeubles, fin de chantier. Devis gratuit, intervention rapide."
        keywords="nettoyage Genève, conciergerie Genève, nettoyage professionnel Suisse romande, entreprise nettoyage Genève, conciergerie immeuble Genève, nettoyage fin chantier Vaud"
        canonical={`${import.meta.env.VITE_SITE_URL}/nettoyage-conciergerie`}
        schema={schema}
      />
      <Header />
      <main>
        <NettoyageHero />
        <NettoyageServices />
        <NettoyageProcess />
        <NettoyageTarifs />
        <NettoyageCTA />
      </main>
      <Footer />
    </div>
  );
}
